class Header {
    constructor() {
        this.html = document.documentElement;
        this.menuTrigger = ".js-header-navigation-trigger";
        this.menuInputs = Array.from(
            document.querySelectorAll(".header__navigation__trigger__input")
        );
        this.subMenuInputs = Array.from(
            document.querySelectorAll(".header__submenu__trigger__input")
        );
        this.headerMain = document.querySelector(".js-header-main");
        this.headerSticky = document.querySelector(".js-header-sticky");
        this.headerSpacer = document.querySelector(".js-header-spacer");
        this.notificationStrip = document.querySelector(
            ".js-notification-strip"
        );
        this.headerSpacerFixed = document.querySelector(
            ".js-header-fixed-spacer"
        );
        this.menuBrekapoint = 1280;
        this.stuck = false;
    }

    toggleScrollLock() {
        const html = this.html;
        if (html.classList.contains("locked")) {
            html.classList.remove("locked");
        } else {
            html.classList.add("locked");
        }

        if (window.innerWidth >= this.menuBrekapoint) {
            html.classList.remove("locked");
        }
    }

    blurHeaderMenu() {
        const inputs = this.menuInputs;
        inputs.forEach(input => {
            input.checked = false;
        });
    }

    blurHeaderSubmenu() {
        const inputs = this.subMenuInputs;
        inputs.forEach(input => {
            input.checked = false;
        });
    }

    handleHeaderNavTriggerClick() {
        const menuTrigger = document.querySelectorAll(this.menuTrigger)[0];
        if (menuTrigger) {
            menuTrigger.addEventListener("click", () => {
                this.toggleScrollLock();
                this.blurHeaderSubmenu();
            });
        }
    }

    headerUpdate() {
        if (this.headerSpacerFixed) {
            this.headerSpacerFixed.style.height = 0;
        }

        if (this.headerMain) {
            this.headerSpacer.style.height = `${this.headerMain.clientHeight}px`;
        }
    }

    headerScroll() {
        if (window.innerWidth >= this.menuBrekapoint) {
            let scrollHeight =
                (document.documentElement &&
                    document.documentElement.scrollTop) ||
                document.body.scrollTop;

            if (scrollHeight > 500) {
                if (
                    !this.headerSticky.classList.contains(
                        "header__sticky--stuck"
                    ) &&
                    !this.stuck
                ) {
                    this.headerSticky.classList.add("header__sticky--stuck");
                    this.stuck = true;
                }
            } else {
                if (this.stuck) {
                    this.stuck = false;
                    this.headerSticky.classList.remove("header__sticky--stuck");
                }
            }
        } else {
            this.headerSticky.classList.remove("header__sticky--stuck");

            this.headerUpdate();
            if (this.notificationStrip) {
                if (window.pageYOffset >= this.notificationStrip.offsetHeight) {
                    this.headerMain.classList.add("header--fixed");
                } else if (
                    window.pageYOffset < this.notificationStrip.offsetHeight
                ) {
                    this.headerMain.classList.remove("header--fixed");
                }
            }
        }
    }

    handleResize() {
        window.addEventListener("resize", () => {
            if (this.headerMain) {
                window.addEventListener("resize", () => {
                    this.timeout = setTimeout(this.headerUpdate.bind(this), 1);
                });
                this.headerUpdate();
            }

            if (window.innerWidth >= this.menuBrekapoint) {
                this.blurHeaderSubmenu();
                this.blurHeaderMenu();
                this.toggleScrollLock();
            }

            this.setHeaderPosition();
        });
    }

    handleScroll() {
        if (this.headerSticky) {
            window.addEventListener("scroll", () => {
                this.timeout = setTimeout(this.headerScroll.bind(this), 1);
            });
        }
    }

    setHeaderPosition() {
        if (this.notificationStrip) {
            if (window.innerWidth <= this.menuBrekapoint) {
                this.headerMain.style.top = `${this.notificationStrip.clientHeight}px`;
            } else {
                this.headerMain.style.top = "0px";
            }
        }
    }

    init() {
        this.handleHeaderNavTriggerClick();
        this.handleResize();
        this.handleScroll();
        this.setHeaderPosition();
    }
}

export default Header;



// WEBPACK FOOTER //
// ../project/craft/src/components/header/header.js